import '../../boot'
import './index.scss'
import { createApp, ref } from 'vue/dist/vue.esm-bundler'
import AppLayoutMixin from '../../app-layout-mixin'
import { NButton, NFormItem, NForm, NCard, NDatePicker } from 'naive-ui'
import EmbedCode from "@/components/embed";


createApp({
    components: { NButton, NFormItem, NForm, NCard, NDatePicker, EmbedCode },
    mixins: [ AppLayoutMixin ],
    setup() {
        return {
           date: ref(Date.parse('1990-01-01'))
        }
    },
    computed: {
        isBeforeBirthday() {
            const today = new Date();
            const birthDate = new Date(this.date);

            return today.getMonth() < birthDate.getMonth() ||
                (today.getMonth() === birthDate.getMonth() &&
                    today.getDate() < birthDate.getDate());
        },

        resultYears() {
            const today = new Date();
            const birthDate = new Date(this.date);

            const yearsDifference = today.getFullYear() - birthDate.getFullYear();

            return this.isBeforeBirthday ? yearsDifference - 1 : yearsDifference;
        },

        resultMonths() {
            const today = new Date();
            const birthDate = new Date(this.date);

            const monthDifference = today.getMonth() - birthDate.getMonth();

            return this.isBeforeBirthday ? monthDifference - 1 : monthDifference;
        },

        resultDays() {
            const today = new Date();
            const birthDate = new Date(this.date);

            const dayDifference = today.getDate() - birthDate.getDate();

            return this.isBeforeBirthday ? dayDifference - 1 : dayDifference;
        }
    }
}).mount('#app')
